import Bottleneck from "bottleneck";
import {QueryClient, QueryClientProvider, useInfiniteQuery, useQuery} from "react-query";
import {toast} from "react-toastify";

const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			refetchOnWindowFocus: false,
		},
	},
});

export const isCurrentPageDenyQuery = (location) => {
	const globalQueryFilterDeny = [
		/^\/$/g,
		/^\/idp\/instructions/g,
		/^\/idp\/link\/.*/g,
	]

	for (let regExp of globalQueryFilterDeny) {
		const matcher = regExp.exec(location.pathname)
		if(matcher) {
			return true;
		}
	}

	console.log(location.pathname, 'no deny')
	return false;
}

const apiLimiter = new Bottleneck({
	maxConcurrent: 5,
});

const randomWaitingDuration = () => {
	// return new Promise((resolve) => setTimeout(resolve, Math.random() * 500 + 500));
	return new Promise((resolve) => setTimeout(resolve, Math.random() * 30 + 20));
};

export const ApiProvider = ({children}) => {
	return (
		<QueryClientProvider client={queryClient}>
			{children}
		</QueryClientProvider>
	);
}

const buildApiProcess = (apiType, calling, process = (data) => data, options, noWait = false) => {
	return apiLimiter.wrap(async (params) => {
		let response = null;
		let error = null;

		const s = Date.now();

		try {
			response = await calling({pageParam: params?.pageParam ?? null});
		} catch (e) {
			error = e;
		}

		const e = Date.now();

		if (!noWait && e - s < 20) {
			await randomWaitingDuration();
		}

		if (response?.data?.errorMessage) {
			error = new Error(response?.data?.errorMessage);
		}

		if (error) {
			toast.error(error.message);
		}

		console.log("Api complete", apiType, response);

		return process({...response, error});
	});
}

export const runApi = (apiType, calling, process = (data) => data, options, noWait = false) =>
	buildApiProcess(apiType, calling, process, options, noWait)();

export const useStartApi = (apiType, calling, process = (data) => data, options, noWait = false) => {
	return useQuery(apiType, buildApiProcess(apiType, calling, process, {
		...options,
	}, noWait), options);
};

export const useContinueApi = (apiType, calling, process = (data) => data, options, noWait = false) => {
	return useInfiniteQuery(apiType, buildApiProcess(apiType, calling, process, {
		...options,
	}, noWait), options);
};
